import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { InfiniteScrollComponent }     from './infinite-scroll/infinite-scroll.component';
import { ScrollingTabsPanelComponent } from './scrolling-tabs-panel/scrolling-tabs-panel.component';
import { ItemDirective }               from './item.directive';
import { ScrollingButtonsComponent }   from './scrolling-buttons/scrolling-buttons.component';
import { IconsModule }                 from '@shared/icons/icons.module';


@NgModule({
  declarations: [
    InfiniteScrollComponent,
    ScrollingTabsPanelComponent,
    ItemDirective,
    ScrollingButtonsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    IconsModule
  ],
  exports:      [
    InfiniteScrollComponent,
    ScrollingTabsPanelComponent,
    ItemDirective,
    ScrollingButtonsComponent
  ]
})
export class ScrollingModule {}
